<template>
    <div class="layout-my-report-item dsp-flex" @click.passive="clickReportItem">
        <div class="layout-mri-avatar">
            <img v-if="!source.strong || (source.strong && source.strong == 1)" v-bind:src="strongPng1" alt="">
            <img v-else-if="source.strong && source.strong == 2" v-bind:src="strongPng2" alt="">
        </div>
        <div class="layout-mri-title" v-if="source.name">{{source.name.slice(0, 8)}}的性格测评报告</div>
        <i class="iconfont icon-xiangyou layout-mri-icon"></i>
    </div>
</template>

<script>
export default {
    name: 'MyReportItem',
    props: {
        source: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            strongPng1: require('../../assets/images/strong/strong-1.png'),
            strongPng2: require('../../assets/images/strong/strong-2.png'),
        }
    },
    mounted() {
        
    },
    methods: {
        clickReportItem() {
            console.log('clickReportItemp--------', this.source)
            this.$store.dispatch('report/resetReportData');
            this.$store.dispatch('report/initReportAIConfig', {
                cb: ()=> {
                    this.$store.dispatch('report/getReportInfo', {
                        detailInfo: this.source,
                        cb: ()=> {
                            // 更新状态
                            var params = {"aitips": 1};
                            this.$store.dispatch('reminder/udpateExtList', {
                                params: params
                            });
                            this.$store.dispatch('strong/getReportStrongInfo', {
                                detailInfo: this.source,
                                sucCb: ()=> {
                                    console.log('sucCb----')
                                    this.$router.replace('/strong-report/'+this.source.id);
                                }
                            })
                        }
                    })
                }
            });
        }
    }
}
</script>